import DocumentViewer from '../document-viewer/document-viewer';
import MobileNav from '../mobilenav/mobilenav';
import Nav from '../nav/nav';
import HomeModal from '../home-modal/home-modal'
import Tile from '../tile/tile'

export default {
  finalize() {
    new HomeModal();
    new DocumentViewer();
    new MobileNav();
    new Nav();
    new Tile();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js